import {DataSource, IFoodFieldsFragment, IUserIngredientFieldsFragment} from "app/gql/graphqlSchema";
import {Tag} from "antd";
import {UnreachableCaseError} from "ts-essentials";

export const FoodTag = ({food}: {food: IFoodFieldsFragment | IUserIngredientFieldsFragment}) => {
  switch (food.__typename) {
    case "Food":
      switch (food.dataSource) {
        case DataSource.CofId:
          return <Tag color="green">CofID</Tag>;
        case DataSource.Cz:
          return <Tag color="cyan">CZ</Tag>;
        case DataSource.Usda:
          return <Tag color="lime">USDA</Tag>;
        case DataSource.Cnf:
          return <Tag color="red">CNF</Tag>;
        default:
          throw new UnreachableCaseError(food.dataSource);
      }
    case "UserIngredient":
      return <Tag color="gold">Custom</Tag>;
    default:
      throw new UnreachableCaseError(food);
  }
};
